import { PRODUCT_KEYS } from '../config/studioProducts'
import { ROLES } from '../constants/roles'
import { useOrganization } from '../contexts/OrganizationContext'
import { useAuth } from './useAuth'

// Creator management is available to external organization admins (and higher)
// with Feed configuration access. Keep this boundary in one place so the
// creators page and composer cannot drift apart.
export function useCanManageCreators() {
  const { hasProductAccess } = useOrganization()
  const { hasRole } = useAuth()

  return hasRole(ROLES.EXTERNAL_ORG_ADMIN) && Boolean(
    hasProductAccess?.(PRODUCT_KEYS.FEED, 'configure'),
  )
}
